import { render } from "./LessonView.vue?vue&type=template&id=5c96ea13&scoped=true"
import script from "./LessonView.vue?vue&type=script&lang=js"
export * from "./LessonView.vue?vue&type=script&lang=js"

import "./LessonView.vue?vue&type=style&index=0&id=5c96ea13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c96ea13"]])

export default __exports__